import { Sidebar_Portal } from 'monica-alexandria';
import { Sidebar_Options } from '../sidebar/Sidebar_Options';
import { sidebar_portal_base_urls } from '../sidebar/sidebarApps';

export const Toolbar_ = (props) => {
  const onInternalNavigate = props?.onInternalNavigate || ((nextPath) => window.location.assign(nextPath));
  const portalBaseUrls = sidebar_portal_base_urls();
  const agencyClick = props?.onAgencyClick || (() => onInternalNavigate(`/${props?.routeLanguage}/agency`));
  const sassClick = props?.onSassClick || (() => onInternalNavigate(`/${props?.routeLanguage}/sass`));
  const goalsClick = props?.onGoalsClick || (() => onInternalNavigate(`/${props?.routeLanguage}/goals`));

  return (
    <Sidebar_Portal
      sidebar={props?.sidebar}
      onSidebar={props?.onSidebar}
      toolsTitle="APPS"
      adminTitle="ADMIN"
      admin
      currentAppKey="godfather"
      routeLanguage={props?.routeLanguage}
      onInternalNavigate={onInternalNavigate}
      baseUrls={portalBaseUrls}
      localRoutes={{ godfather: `/${props?.routeLanguage}` }}
    >
      <Sidebar_Options
        sidebar={props?.sidebar}
        activeOption={props?.activeOption}
        onGoalsClick={goalsClick}
        onAgencyClick={agencyClick}
        onSassClick={sassClick}
      />
    </Sidebar_Portal>
  );
};
